/*global swal*/

import './style.less';
import { keyBy } from 'lodash';

import editLevelModalTemplate from 'modals/editLevel/template.html';
import editLevelModalCrtl from 'modals/editLevel';

export default function($log, $uibModal, ProfileClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { profile_uid, company_id } = ProfileClass.profileComplete.profile;

  vm.edit = (level, index) => {
    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: editLevelModalTemplate,
        controller: editLevelModalCrtl,
        controllerAs: 'editLevelModalCrtl',
        resolve: {
          level: () => level
        }
      })
      .result.then(() => activate())
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.delete = (level, index) => {
    if (level.count !== 0) return swal('Hold Up', 'Please remove employees before deleting this level.', 'warning');
    ApiClass.companiesIdTypeTypeIdDelete({
      manage: true,
      id: company_id,
      type: 'levels',
      type_id: level.level_id
    })
      .then(() => vm.levels.splice(index, 1))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.add = name => {
    vm.laddaAdd = true;
    ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'levels' }, { name })
      .then(({ data: { item } }) => {
        item.count = 0;
        cleanForm();
        expose([item, ...vm.levels]);
        vm.laddaAdd = false;
      })
      .catch(error => {
        vm.laddaAdd = false;
        $log.error(error);
        throw error;
      });
  };

  function cleanForm() {
    delete vm.name;
    vm.levelForm.$setPristine();
    vm.levelForm.$setUntouched();
  }

  function expose(levels) {
    vm.levels = Object.assign([], levels);
    vm.levelsDict = keyBy(levels, 'level_id');
  }

  function activate() {
    $log.debug('levels Controller Activated');
    ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
      queryParams: { levels: true, count: true }
    })
      .then(({ data: { company, levels } }) => {
        expose(levels);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/levels/index.js